export interface WidgetMessage {
    type: string;
    payload?: unknown;
}

export const sendMessage = (message: WidgetMessage) => {
    const referrer = document.referrer;
    if (referrer) {
        window.parent.postMessage(message, referrer);
    }
};

export const sendWidgetMessage = (targetOrigin: string, message: WidgetMessage) => {
    if (!window.top) {
        return;
    }
    const frames = window.top.frames;
    const windows = Object.values(frames).slice(1);
    windows.forEach(window => {
        window.postMessage(message, targetOrigin);
    });
};
